import api, { apiWrapper } from '../api/axios';

export const getCustomers = async ({
  status = 'all',
  search=null,
  page = 1,
  pageSize = 20,
  paginate = true,
  branch=0
}) => {
  let params = {
    status,
    page,
    branch,
    page_size: pageSize,
    paginate: paginate
  };
  if (search != null) {
    params = { ...params, search };
  }
  return apiWrapper(() => api.get(`/customer/`, { params }));
};

export const createCustomer = async (data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.post("/customer/", formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const updateCustomer = async (id, data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.put(`/customer/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const updateCustomerPartial = async (id, data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.patch(`/customer/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const toggleCustomerStatus = async (id, isActive) => {
  return apiWrapper(() => api.patch(`/customer/${id}/${isActive ? 'activate' : 'deactivate'}/`));
};

const construct_form_data = (data) => {

  let form = new FormData();

  // Add text fields
  form = add_field(form, 'name', data?.name);
  form = add_field(form, 'phone', data?.phone);
  form = add_field(form, 'email', data?.email);
  form = add_field(form, 'short_code', data?.short_code);
  form = add_field(form, 'address_line1', data?.address_line1);
  form = add_field(form, 'address_line2', data?.address_line2);
  form = add_field(form, 'city', data?.city);
  form = add_field(form, 'state', data?.state);
  form = add_field(form, 'pincode', data?.pincode);
  form = add_field(form, 'branch_id', data?.branch_id);
  form = add_field(form, 'loading_charge', data?.loading_charge);
  form = add_field(form, 'unloading_charge', data?.unloading_charge);
  form = add_field(form, 'toll_charge', data?.toll_charge);
  form = add_field(form, 'freight_charge', data?.freight_charge);
  form = add_field(form, 'detention_charge', data?.detention_charge);
  form = add_field(form, 'parking_charge', data?.parking_charge);
  form = add_field(form, 'custom_fields_json', JSON.stringify(data?.custom_fields || []));
  form = add_field(form, 'mis_fields_json', JSON.stringify(data?.mis_fields || []));
  form = add_field(form, 'is_active', data?.is_active ? 1 : 0);

  // Add file fields (make sure these are actual File objects from input type="file")
  form = add_field(form, 'sla_contract', data?.sla_contract);

  return form;
};

const add_field = (form, key, value) => {
  if (value) {
    form.append(key, value);
  }
  return form;
};
